import React from "react";
import ReactDOM from "react-dom/client";
import Map from "../components/staticMap/SiteMap";

export default () => {
  const element = document.getElementById("site-static-map-root");
  if (!element) return;

  if (!element.dataset.gcp || !element.dataset.resources || !element.dataset.site) return;

  ReactDOM.createRoot(element).render(
    <Map
      gcp={JSON.parse(element.dataset.gcp)}
      resources={JSON.parse(element.dataset.resources)}
      site={JSON.parse(element.dataset.site)}
      width={element.clientWidth}
    />,
  );
};
